var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Shop-White"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shop-White",
    clipPath: "url(#clip-Shop-White)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(-0.318 1.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M28.15,10.19a1.871,1.871,0,0,0-1.88-1.68H24.95v3.76a2.03,2.03,0,0,1-4.06,0V8.51H15.75v3.76a2.03,2.03,0,0,1-4.06,0V8.51H10.38a1.908,1.908,0,0,0-1.87,1.67L7.3,25.98a4.353,4.353,0,0,0,1.06,3.21,4.453,4.453,0,0,0,3.03,1.54H24.87a4.475,4.475,0,0,0,4.48-4.46v-.29ZM22.27,20.1l-4.2,4.2a1.271,1.271,0,0,1-.9.34,1.255,1.255,0,0,1-.9-.34l-2-2a1.255,1.255,0,0,1-.34-.9,1.271,1.271,0,0,1,.34-.9,1.361,1.361,0,0,1,1.8,0l1.1,1.1,3.4-3.4a1.271,1.271,0,0,1,.9-.34,2.056,2.056,0,0,1,.76.21l.14.13a1.255,1.255,0,0,1,.34.9A1.943,1.943,0,0,1,22.27,20.1Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.522
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M22.916,12.271v-4a4.653,4.653,0,0,0-4.6-4.6h0a4.653,4.653,0,0,0-4.6,4.6v4",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopWhite);
export default __webpack_public_path__ + "static/media/Shop-White.49aa3e8ae8512752c80cfac5c404c244.svg";
export { ForwardRef as ReactComponent };